import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

/**
 * Big radio-style "card" — used in plan pickers, payment-method choosers.
 */
export function OptionCard({
  selected,
  onSelect,
  children,
  className,
  disabled = false,
  asLabel = true,
  name,
  value,
}: {
  selected: boolean;
  onSelect: () => void;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  asLabel?: boolean;
  name?: string;
  value?: string;
}) {
  const Wrapper: React.ElementType = asLabel ? 'label' : 'div';
  return (
    <Wrapper
      className={cn(
        'block p-4 rounded-lg border-2 transition cursor-pointer',
        selected
          ? 'border-brand bg-brand-subtle dark:border-brand-dm dark:bg-brand-dm-subtle/30'
          : 'border-zinc-200 dark:border-zinc-700 hover:border-zinc-300 dark:hover:border-zinc-600',
        disabled && 'opacity-50 cursor-not-allowed',
        className,
      )}
      onClick={() => !disabled && onSelect()}
    >
      {asLabel && name && (
        <input
          type="radio"
          name={name}
          value={value}
          checked={selected}
          onChange={() => !disabled && onSelect()}
          className="sr-only"
        />
      )}
      {children}
    </Wrapper>
  );
}
